export function normalizeString(s: string): string {
  return s
    .toLowerCase()
    .replace(/ /g, '')
    .replace(/[\n\r!#$%&()*+,.=@^_`~-]/g, '')
}
